module.exports = __webpack_public_path__ + "static/nutrikane-logo-d9bf0ca6dfda0fecdee5f2bfa7d460f4.svg";